import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../stores/userStore";
import { Modal, PasswordInput, Button, Stack, Alert, Text } from "@mantine/core";

export function ChangePasswordModal({ open, mustChange }) {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();
  const clearUser = useUserStore((state) => state.clearUser);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);
    setPending(true);

    const formData = new FormData(event.currentTarget);
    const newPassword = formData.get("newPassword");
    const confirmPassword = formData.get("confirmPassword");

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      setPending(false);
      return;
    }

    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters long.");
      setPending(false);
      return;
    }

    const token = useUserStore.getState().token;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/change-password`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword, forcedChange: mustChange }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to change password.");
      }

      setSuccess("Password changed successfully! Redirecting...");

      setTimeout(() => {
        clearUser();
        navigate('/login');
      }, 2000);

    } catch (e) {
      setError(e.message);
    } finally {
      setPending(false);
    }
  };

  return (
    <Modal
      opened={open}
      onClose={() => {}} // Prevent closing if forced
      withCloseButton={!mustChange}
      closeOnClickOutside={!mustChange}
      closeOnEscape={!mustChange}
      title="Change Your Password"
      centered
    >
      <Text size="sm" c="dimmed" mb="md">
        {mustChange
          ? "You must update your temporary password to continue."
          : "Please enter your new password."}
      </Text>
      <form onSubmit={handleSubmit}>
        <Stack>
          <PasswordInput
            label="New Password"
            name="newPassword"
            required
            minLength={6}
            placeholder="Enter new password"
          />
          <PasswordInput
            label="Confirm New Password"
            name="confirmPassword"
            required
            minLength={6}
            placeholder="Confirm new password"
          />
          
          {error && <Alert color="red" variant="light">{error}</Alert>}
          {success && <Alert color="green" variant="light">{success}</Alert>}
          
          <Button type="submit" fullWidth loading={pending} mt="md">
            {pending ? "Updating..." : "Update Password"}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}